'use client'

import { logPageView } from '@/utils/eventLogging'
import { usePathname } from 'next/navigation'
import { useEffect, useRef } from 'react'

/**
 * Logs a PAGE_VIEW event when the component mounts or the pathname changes.
 * Deduplicates so the same path is not logged twice in a row.
 */
export function usePageView(metadata?: Record<string, unknown>) {
    const pathname = usePathname()
    const lastLogged = useRef<string | null>(null)

    useEffect(() => {
        if (pathname && pathname !== lastLogged.current) {
            lastLogged.current = pathname
            logPageView({ path: pathname, metadata })
        }
    }, [pathname]) // metadata intentionally excluded to avoid re-logging on object identity changes
}
